module.exports = __webpack_public_path__ + "img/nehmo_weert-5340-0620.7d7826f0.jpg";